import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { getApiUrl } from './http-client';

export interface StadiumName {
  baseName: string;
  displayName: string;
  sponsorName: string | null;
  version: number;
  nextRenameCost: number;
}

@Injectable({ providedIn: 'root' })
export class StadiumNameApi {
  private readonly http = inject(HttpClient);

  get(clubId: string): Promise<StadiumName> {
    return firstValueFrom(this.http.get<StadiumName>(this.url(clubId)));
  }

  rename(clubId: string, name: string, expectedVersion: number): Promise<StadiumName> {
    return firstValueFrom(this.http.put<StadiumName>(this.url(clubId), { name, expectedVersion }));
  }

  private url(clubId: string): string {
    return getApiUrl(`/api/clubs/${encodeURIComponent(clubId)}/stadium/name`);
  }
}
